import { voteLibraryPrompt } from '@Lib/prompt-toolbox';
import { Votes } from '@Models/types';
import { ThumbsUp, ThumbsDown } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';

interface UpvoteProps {
  promptId: string;
  votes?: Votes;
}

const Upvote = ({ promptId, votes }: UpvoteProps) => {
  const [vote, setVote] = useState<'UPVOTE' | 'DOWNVOTE' | undefined>();
  const [totalVotes, setTotalVotes] = useState(0);

  useEffect(() => {
    const email = localStorage.getItem('email');
    if (votes && email) {
      const upvoted = votes.upvote?.includes(email);
      const downvoted = votes.downvote?.includes(email);

      setVote(upvoted ? 'UPVOTE' : downvoted ? 'DOWNVOTE' : undefined);
      setTotalVotes(
        (votes.upvote?.length || 0) - (votes.downvote?.length || 0)
      );
    }
  }, [votes]);

  const handleVote = async (type: 'upvote' | 'downvote' | 'cancel') => {
    if (type === 'upvote') {
      if (vote === 'DOWNVOTE') {
        setTotalVotes((prev) => prev + 2);
      } else {
        setTotalVotes((prev) => prev + 1);
      }
      setVote('UPVOTE');
    } else if (type === 'downvote') {
      if (vote === 'UPVOTE') {
        setTotalVotes((prev) => prev - 2);
      } else {
        setTotalVotes((prev) => prev - 1);
      }
      setVote('DOWNVOTE');
    } else {
      setVote(undefined);
      setTotalVotes((prev) => (vote === 'UPVOTE' ? prev - 1 : prev + 1));
    }

    await voteLibraryPrompt(promptId, type);
  };

  return (
    <div className="flex flex-col gap-y-1">
      <ThumbsUp
        data-testid="test-upvote-btn"
        mirrored
        size={24}
        color={vote === 'UPVOTE' ? '#34D399' : undefined}
        onClick={() => handleVote(vote === 'UPVOTE' ? 'cancel' : 'upvote')}
      />
      <div className="h-full border-2 border-primary-700"></div>
      <p data-testid="test-vote-text" className="bg-neutral-200 text-center">
        {totalVotes}
      </p>
      <div className="h-full border-2 border-primary-700"></div>
      <ThumbsDown
        data-testid="test-downvote-btn"
        mirrored
        size={24}
        color={vote === 'DOWNVOTE' ? '#FB6D4E' : undefined}
        onClick={() => handleVote(vote === 'DOWNVOTE' ? 'cancel' : 'downvote')}
      />
    </div>
  );
};

export default Upvote;
